import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { InputBase } from './input-base'

export function toFormGroup(inputs: InputBase<string>[]): UntypedFormGroup {
  const group: Record<string, UntypedFormControl> = {}

  inputs.forEach(input => {
    group[input.key] = input.required
      ? new UntypedFormControl(input.value || '', Validators.required)
      : new UntypedFormControl(input.value || '')
  })
  return new UntypedFormGroup(group)
}
